
















































import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, elementWidth } from '@/mixins'
import easyapi from '@/easyapi'
import { extender_vendor_t } from '@/types/api'
import InteractiveVw from '@/components/InteractiveVw.vue'
import RxDragRow from '@/components/RxDragRow.vue'
import SaveCancelDiscard from '@/components/dialogs/SaveCancelDiscard.vue'
import { deepCopy } from '@/utils'
import { isEqual } from 'lodash'

// TODO: fade + sort list, the RXs which have been using in other VW (see rxInfo.activeState) should be:
//      1. sorted to last.
//      2. faded.

export default mixins(vwDialogMixin, elementWidth).extend({
  components: {
    InteractiveVw,
    RxDragRow,
    SaveCancelDiscard,
  },
  data (): {
    nameFilterStr: string | null
    copiedVw: IVW | null,
    draggingRx: IDevice | null,
    hoveringRx: IDevice | null,
    showSaveCancelDiscard: boolean,
    draggerBlinking: boolean,
  } {
    return {
      nameFilterStr: '',
      copiedVw: null,
      draggingRx: null,
      hoveringRx: null,
      showSaveCancelDiscard: false,
      draggerBlinking: false,
    }
  },
  computed: {
    vw (): IVW | null { return this.dialog.vw },
    rxList (): IDevice[] {
      if (!this.copiedVw) {return []}
      const vendor = this.copiedVw.vendor
      return this.$s.$state.device.list.filter(x => x.deviceType === 'RX' && x.vendor === vendor)
      },
    filteredRxList (): IDevice[] {
      const tmp = this.nameFilterStr ? this.nameFilterStr.toLowerCase() : ''
      return this.rxList.filter(x => x.deviceName.toLowerCase().includes(tmp))
    },
  },
  methods: {
    async closeThisDialogSafely () {
      this.closeThisDialog()
    },
    preview () {
      // if (!this.copiedVw) {return}
      // easyapi.vwPreviewStart(this.copiedVw)
    },
    onOsdSelect (ev: any) {
      if (this.$refs.interactiveVw) {
        this.$refs.interactiveVw['onOsdSelect'](ev)  // HACK: no better way?
      }
    },
    closeThisDialogAfterConfirm () {
      if (!this.copiedVw) { console.error('[To Developer] Impossible'); return }
      const vwid = this.copiedVw.id
      const originalVw = this.$s.device.getters.vwList.find(vw => vwid === vw.id)
      if (!originalVw) { console.error('[To Developer] Impossible'); return }
      if (isEqual(this.copiedVw, originalVw)) {
        this.closeThisDialogSafely()
      } else {
        // TODO: onbeforeunload to handle "back" button
        // window.onbeforeunload = function() { return 'Your work will be lost.'; };
        this.showSaveCancelDiscard = true
      }
    },
    getMappedDisplayIndex (mac: string): number {
      if (!this.copiedVw) { return -1 }
      const rx = this.copiedVw.rxList.find(x => x.mac === mac)
      if (!rx) {return -1}
      return rx.displayIndex
    },
    blinkDragger () {
      this.draggerBlinking = true
      setTimeout(() => {
        this.draggerBlinking = false
      }, 1000)
    },
    async save () {
      if (!this.copiedVw) { return }
      await easyapi.vwPreviewRestore()
      const ok = await easyapi.modifyVw(this.copiedVw)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  watch: {
    'dialog.vw' (nv: IVW|null) {
      if (nv) {
        this.copiedVw = deepCopy(this.dialog.vw)
        this.preview()
      }
    },
  },
  mounted () {
    if (this.$route.name !== 'vwlst_details_rxmap') {
      console.warn('[To Developer] Some dialogs store states in VM instead of URL, it is impossible to keep the state after refreshing, so redirect to RxMapper')
      this.$router.replace({ name: 'vwlst_details_rxmap', params: {vwid: this.$route.params.vwid} })
    }
    this.watchElementWidth('vwPreviewContainer', ['dialog.vw'])
  }
})
